export default __webpack_public_path__ + "static/media/doctors.103d6173.png";